export const statusBoletimMedicaoEnum = {
    Cancelado: 0,
    Criado: 1,
    EnviadoParaAprovacaoFiscalTerceiro: 2,
    DevolvidoParaCorrecaoFornecedor: 3,
    AprovadoParaEnvioNotaFiscal: 7,
    NotaFiscalEnviadaParaAprovacao: 8,
    NotaFiscalDevolvidaParaCorrecao: 9,
    NotaFiscalAprovada: 10,
    RequisicaoCadastrada: 11,
    MemoriaDeCalculoAtualizada: 12,
    EnviadoParaAprovacaoFiscalObras: 13,
    AprovadoParaColetaAssinaturaFornecedor: 14,
    AprovadoParaColetaAssinaturaFiscalTerceiro: 15,
    AprovadoParaColetaAssinaturaFiscalObras: 16,
    DevolvidoParaReassinarFornecedor: 17,
    AnexoComplementarAdicionado: 18,
    AnexoComplementarExcluido: 19,
}

export const statusCronogramaEnum = {
    Rascunho: 'Rascunho',
    AguardandoAprovacao: 'AguardandoAprovacao',
    DevolvidoParaCorrecao: 'DevolvidoParaCorrecao',
    Aprovado: 'Aprovado',
}

export const statusBoletinsMedicao = [
    { id: 0, descricao: 'Boletim Cancelado', classeCor: 'danger', grupoFiltro: 'Devolucao' },
    { id: 1, descricao: 'Boletim Criado', classeCor: 'primary', grupoFiltro: 'Aprovacao' },
    { id: 2, descricao: 'Enviado Para Aprovação do Fiscal Terceiro', classeCor: 'primary', grupoFiltro: 'Aprovacao' },
    { id: 3, descricao: 'Devolvido Para Correção do Fornecedor', classeCor: 'warning', grupoFiltro: 'Devolucao' },
    { id: 7, descricao: 'Aprovado Para Envio de Nota Fiscal', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 8, descricao: 'Nota Fiscal Enviada Para Aprovação', classeCor: 'primary', grupoFiltro: 'Aprovacao' },
    { id: 9, descricao: 'Nota Fiscal Devolvida Para Correção', classeCor: 'warning', grupoFiltro: 'Devolucao' },
    { id: 10, descricao: 'Nota Fiscal Aprovada', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 11, descricao: 'Requisição Cadastrada', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 12, descricao: 'Memória de Cálculo Atualizada', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 13, descricao: 'Enviado Para Aprovação do Fiscal de Obras', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 14, descricao: 'Aprovado Para Coleta de Assinatura do Fornecedor', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 15, descricao: 'Aprovado Para Coleta de Assinatura do Fiscal Terceiro', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 16, descricao: 'Aguardando Aprovação dos Documentos', classeCor: 'success', grupoFiltro: 'Aprovacao' },
    { id: 17, descricao: 'Devolvido para Reassinatura do Fornecedor', classeCor: 'warning', grupoFiltro: 'Devolucao' },
    { id: 18, descricao: 'Anexo Complementar Adicionado', classeCor: 'info', grupoFiltro: 'Aprovacao' },
    { id: 19, descricao: 'Anexo Complementar Excluído', classeCor: 'secondary', grupoFiltro: 'Aprovacao' },
]

export function obterDescricaoStatusBoletimMedicao(statusId) {
    const status = statusBoletinsMedicao.find(status => status.id === statusId)
    return status ? status.descricao : ''
}

export function obterClasseCorStatusBoletimMedicao(statusId) {
    const status = statusBoletinsMedicao.find(status => status.id === statusId)
    return status ? status.classeCor : ''
}

export const etapaBoletimMedicao = [
    { id: 1, descricao: 'Envio do boletim medição para aprovação do fiscal terceiro', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 2, descricao: 'Devolução do boletim medição para correção pelo fornecedor', reinicioAnalise: true, descricaoReinicioAnalise: 'Cadastro de Boletim Medição' },
    { id: 6, descricao: 'Aprovação para Envio de Nota Fiscal', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 7, descricao: 'Envio de Nota Fiscal para Aprovação', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 9, descricao: 'Aprovação para Cadastro de Requisição', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 10, descricao: 'Cadastro de Requisição', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 11, descricao: 'Reinicio de Processo', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 12, descricao: 'Envio do boletim de medição para aprovação por Suape', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 13, descricao: 'Aprovação para coleta de assinatura do fornecedor', reinicioAnalise: true, descricaoReinicioAnalise: 'Assinatura do Fornecedor' },
    { id: 8, descricao: 'Devolução de Nota Fiscal para Correção', reinicioAnalise: true, descricaoReinicioAnalise: 'Cadastro de Nota Fiscal' },
    { id: 14, descricao: 'Aprovação para coleta de assinatura do fiscal terceiro', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 15, descricao: 'Aprovação para coleta de assinatura de Suape', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 16, descricao: 'Devolução do boletim para reassinatura pelo fornecedor', reinicioAnalise: false, descricaoReinicioAnalise: '' },
    { id: 17, descricao: 'Reenvio para validação de assinatura por Suape', reinicioAnalise: false, descricaoReinicioAnalise: '' },
]

export const etapaBoletimMedicaoEnum = {
    EnvioBoletimMedicaoParaAprovacao: 1,
    DevolucaoBoletimMedicaoParaCorrecao: 2,
    AprovacaoParaEnvioNotaFiscal: 6,
    EnvioNotaFiscalParaAprovacao: 7,
    DevolucaoNotaFiscalParaCorrecao: 8,
    AprovacaoParaCadastroRequisicao: 9,
    CadastroRequisicao: 10,
    ReinicioProcesso: 11,
    EnvioParaAprovacaoFiscalObras: 12,
    AprovacaoParaColetaAssinaturaFornecedor: 13,
    AprovacaoParaColetaAssinaturaFiscalTerceiro: 14,
    AprovacaoParaColetaAssinaturaFiscalObras: 15,
    DevolucaoParaReassinarFornecedor: 16,
    ReenvioParaValidacaoAssinaturaFiscalObras: 17,
}

export const motivosDevolucaoAnaliseBoletimMedicaoEnum = {
    DadosIncorretos: 1,
    DocumentacaoIncompleta: 2,
    OutrosDesvios: 3,
}

export const motivosDevolucaoAnaliseBoletimMedicao = [
    { id: 1, descricao: 'Dados Incorretos' },
    { id: 2, descricao: 'Documentação Incompleta' },
    { id: 3, descricao: 'Outros Desvios' },
]

export const unidadeMedidaItemContratoEnum = {
    M: 1,
    M2: 2,
    M3: 3,
    H: 4,
    Diaria: 5,
    Mes: 6,
    DiariasPorAno: 7,
    MensalidadePorAno: 8,
    FurosPorAno: 9,
    Metro2PorAno: 10,
    AcaoPorAno: 11,
    HorasPorAno: 12,
    Unidade: 13,
    UnidadePorMes: 14,
    VeiculoPorAno: 15,
    ToneladaPorKM: 16,
    T: 17,
    UD: 18,
    CJ: 19,
    CHP: 20
}

export const unidadeMedidaItemContrato = [
    { id: 1, descricao: "Metro" },
    { id: 2, descricao: "Metro Quadrado" },
    { id: 3, descricao: "Metro Cúbico" },
    { id: 4, descricao: "Hora" },
    { id: 5, descricao: "Diária" },
    { id: 6, descricao: "Mes" },
    { id: 7, descricao: "Diárias Por Ano" },
    { id: 8, descricao: "Mensalidade Por Ano" },
    { id: 9, descricao: "Furos Por Ano" },
    { id: 10, descricao: "Metro Quadrado Por Ano" },
    { id: 11, descricao: "Ação Por Ano" },
    { id: 12, descricao: "Horas Por Ano" },
    { id: 13, descricao: "Unidade" },
    { id: 14, descricao: "Unidade Por Mês" },
    { id: 15, descricao: "Veículo Por Ano" },
    { id: 16, descricao: "Tonelada Por Km" },
    { id: 17, descricao: "Tonelada" },
    { id: 18, descricao: "UD" },
    { id: 19, descricao: "Conjunto" },
    { id: 20, descricao: "Calor e Energia Combinados" }
]

export function obterDescricaoUnidadeMedidaItemContrato(unidadeMedidaId) {
    const unidadeMedida = unidadeMedidaItemContrato.find(unidadeMedida => unidadeMedida.id === unidadeMedidaId)
    return unidadeMedida ? unidadeMedida.descricao : ''
}

export const statusItemBoletimMedicaoEnum = {
    AguardandoAprovacaoFiscalTerceiro: 1,
    ReprovadoFiscalTerceiro: 2,
    AguardandoAprovacaoFiscalObras: 3,
    ReprovadoFiscalObras: 4,
    AprovadoFiscalObras: 5,
}

export const statusItemBoletimMedicao = [
    { id: 1, descricao: "Aguardando Aprovação Fiscal Terceiro", icone: "fa-clock" },
    { id: 2, descricao: "Reprovado Fiscal Terceiro", icone: "fa-refresh" },
    { id: 3, descricao: "Aguardando Aprovação Fiscal Obras", icone: "fa-clock" },
    { id: 4, descricao: "Reprovado Fiscal Obras", icone: "fa-refresh" },
    { id: 5, descricao: "Aprovado Fiscal Obras", icone: "fa-check" },
]

export const tipoAnexoBoletimMedicaoEnum = {
    BoletimMedicao: 1,
    NotaFiscal: 2,
    CertidoesDocumentosComprobatorios: 3,
    OutrosDocumentos: 4,
    MedicaoNaoAssinada: 5,
    MedicaoAssinadaPeloFornecedor: 6,
    MedicaoAssinadaPeloFiscalTerceiro: 7,
    MedicaoAssinadaPeloFiscalObras: 8,
    MemoriaCalculoAssinadaPeloFornecedor: 9,
    CronogramaFisicoFinanceiroAssinadoPeloFornecedor: 10,
    CurvaSAssinadaPeloFornecedor: 11,
    PlantaFaladaAssinadaPeloFornecedor: 12,
    DeclaracaoVinculoAssinadaPeloFornecedor: 13,
    MemoriaCalculoAssinadaPeloFiscalObras: 14,
    CronogramaFisicoFinanceiroAssinadoPeloFiscalObras: 15,
    CurvaSAssinadaPeloFiscalObras: 16,
    PlantaFaladaAssinadaPeloFiscalObras: 17,
    DeclaracaoVinculoAssinadaPeloFiscalObras: 18,
}

export const abaBoletimMedicaoCodigo = {
    PlanilhaMedicao: 'PLANILHA_MEDICAO',
    MemoriaCalculo: 'MEMORIA_CALCULO',
    Cronograma: 'CRONOGRAMA',
    CurvaS: 'CURVA_S',
    DeclaracaoVinculos: 'DECLARACAO_VINCULOS',
    PlantaFalada: 'PLANTA_FALADA',
}
